import { apiFetch } from "@hp/api-client";
import type { CompanyDisallowance } from "@hp/types";

/**
 * Fetch one CompanyDisallowance by id. Wrap in `useQuery` with a queryKey
 * of `["company-disallowances", id]`.
 */
export async function getCompanyDisallowance(id: string, signal?: AbortSignal): Promise<CompanyDisallowance> {
  return apiFetch<CompanyDisallowance>(`/company-disallowances/${encodeURIComponent(id)}`, {
    method: "GET",
    signal,
  });
}
